export const bscId =process.env.REACT_APP_CHAIN_ID
export const serverPath = process.env.REACT_APP_serverPath;